export default __webpack_public_path__ + "static/media/icon-attackers.9dcd73c8.png";